import React, { Component } from "react";
import { Line } from "./Line";
import { connect } from "react-redux";
import { sampleEdit } from "../actions/songactions";

class SampleSelection extends Component {
  state = {
    drag: false,
    mouseJustClicked: false,
    mouseJustUp: false,
  };

  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.sampleBlob = React.createRef();

    this.mouseClick = this.mouseClick.bind(this);
    this.calculateSampleBlobSize = this.calculateSampleBlobSize.bind(this);
    this.moveSample = this.moveSample.bind(this);

    this.mouseDown = this.mouseDown.bind(this);
    this.mouseUp = this.mouseUp.bind(this);
    this.mouseMove = this.mouseMove.bind(this);

    this.latestDrag = 0;
  }

  calculateSampleBlobSize(song) {
    return ((song.endSecond - song.startSecond) / song.duration) * 100.0;
  }

  mouseDown() {
    this.setState({
      drag: true,
    });
  }

  mouseUp(e) {
    const { mouseJustClicked } = this.state;

    this.setState({
      drag: false,
      mouseJustUp: true,
    });

    if (!mouseJustClicked) {
      const width = this.sampleBlob.current.offsetWidth;
      this.moveSample(e.clientX - width / 2, true);
    }
    setTimeout(() => this.setState({ mouseJustUp: false }), 500);
  }

  mouseMove(e) {
    const { drag } = this.state;

    const width = this.sampleBlob.current.offsetWidth;

    if (drag) {
      this.moveSample(e.clientX - width / 2, false);
    }
  }

  mouseClick(e) {
    const { drag, mouseJustUp } = this.state;

    if (!drag && !mouseJustUp) {
      this.moveSample(e.clientX, true);
    }

    this.setState({
      mouseJustClicked: true,
    });

    setTimeout(() => this.setState({ mouseJustClicked: false }), 500);
  }

  moveSample(clientX, commit) {
    const { dispatch, uniqueName, songs } = this.props;
    const song = songs[uniqueName];

    var rect = this.container.current.getBoundingClientRect();
    var x = clientX - rect.left; //x position within the element.

    const sampleSize = this.calculateSampleBlobSize(song) / 100;

    const size = this.container.current.clientWidth;
    const percentage = Math.max(Math.min(x / size, 1.0 - sampleSize), 0);

    dispatch(sampleEdit(percentage, uniqueName, commit));
  }

  render() {
    const { songs, uniqueName } = this.props;

    const song = songs[uniqueName];
    const duration = song.duration;

    const sampleSize = this.calculateSampleBlobSize(song);

    const positionX = (song.startSecond / duration) * 100.0;

    let thirdSection = 100 - positionX - sampleSize;

    return (
      <div
        ref={this.container}
        style={{
          display: "flex",
          flexDirection: "row",
          marginLeft: "20%",
          marginRight: "20%",
        }}
        onClick={this.mouseClick}
      >
        <Line
          color="rgba(127, 63, 191)"
          size={`${positionX}%`}
          thickness="5px"
          marginTop="5px"
          boxShadow="1px 1px 2px black"
        />
        <Line
          passRef={this.sampleBlob}
          color="rgba(48, 155, 155, 0.3)"
          size={`${sampleSize}%`}
          thickness="15px"
          boxShadow="8px 8px 8px blue"
          onMouseMove={this.mouseMove}
          onMouseDown={this.mouseDown}
          onMouseUp={this.mouseUp}
          onMouseLeave={this.mouseUp}
        />
        {thirdSection <= 0 ? (
          <React.Fragment />
        ) : (
          <Line
            color="rgba(127, 63, 191)"
            size={`${thirdSection}%`}
            thickness="5px"
            marginTop="5px"
            boxShadow="1px 1px 2px black"
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  songs: state.songs.songs,
});

export default connect(mapStateToProps)(SampleSelection);
